import React, { FunctionComponent } from 'react';
import { Experiments } from '../../constants/experiments';

import { DonateButton } from '../DonateButton/DonateButton';
import { MarkSuccessOnClick } from '../MarkSuccessOnClick/MarkSuccessOnClick';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => (
  <>
    <MarkSuccessOnClick
      testSlug={Experiments.b2c_hide_sticky_bar}
      successType="StaticDonateButtonClick"
    >
      <DonateButton
        key="donateButton"
        className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingDataPageSection="FundraisingCTA"
      />
    </MarkSuccessOnClick>
    <Share successType="StaticShareButtonClick" />
  </>
);

export default FundraisingCTA;
